export interface UserData {
    id: number,
    name: string,
    email: string,
    password?: string,
    confirm_password?: string,
    created_at?: string,
    roles: RoleData[],
    admin: boolean,
    role_ids?: number[],
    rma_areas: number[],
    products: string[],
    language?: string,
    forcing_change_password: boolean
}

export interface RoleData {
    id: number,
    name: string,
    permissions: string[],
    created_at?: string
}

export interface ChangePasswordData {
    old_password: string;
    password: string;
    confirm_password: string;
}

export interface LocalServerAuthData {
    id: number,
    name: string,
    password?: string,
    confirm_password?: string,
    products: string[],
    ssh_address: string,
    created_at?: string,
    created_by_name?: string,
    refresh_password?: boolean
}


export const USER_LANGUAGES = [
    { key: 'en', value: 'en', text: 'English' },
    { key: 'cn', value: 'cn', text: 'Chinese' }
]